import React from 'react';

const Place = ({ payload, active = false }) => {
  const { id, title, url } = payload;

  return (
    <p
      className={`c-places__place u-mb-0 ${
        active ? 'c-places__place--active' : ''
      }`}
    >
      <a
        href={url}
        title={title}
        dangerouslySetInnerHTML={{ __html: title }}
      ></a>
    </p>
  );
};

export default Place;
